import useGet from "api/useGet";
import React, {useEffect, useRef, useState} from "react";
import { ContentsSection, PageSubHeader, PageBody, InputSection } from "component/app/items";
import { Header } from "component/elements/header";
import { BtnItem} from "../../component/basic/btns";
import { useNavigate, useParams } from "react-router-dom";
import { InputItemBox, TextAreaItem } from "../../component/basic/formItems";
import * as fatchSet from "../../api/api";
import { BottomErrMsg } from "../../component/basic/popup";

const ModfiyRequest = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id

    const [beginTime, setBeginTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [memo, setMemo] = useState('');
    const [btnChk, setBtnChk] = useState(true);
    const [bottomMsgData, setBottomMsgData] = useState({chk : 0});

    const workHistoryApi = useGet({url: `/work/history/detail?company_id=${localStorage.getItem("companyId")}&work_history_id=${id}`, loginType: "login"});
    const workHistoryData = workHistoryApi?.data;

    function handleResize() {
        var totalSize = 0;
        let headerSize = document.querySelectorAll(".header")[0].clientHeight,
            headerItemSize = document.querySelectorAll(".headerItem")[0].clientHeight,
            pageBtnSize = document.querySelectorAll(".pageBtn")[0].clientHeight,
            viewSize = document.documentElement.clientHeight;

        totalSize = viewSize - (headerSize + headerItemSize + pageBtnSize + 33)

        document.querySelectorAll(".pageBody")[0].style.height = `${totalSize}px`;
    }

    useEffect(() => {
        handleResize()
    }, [workHistoryData]);

    useEffect(() => {
        if (beginTime && (!workHistoryData?.work_history?.real_end_time || endTime) && memo) {
            setBtnChk(false);
        } else {
            setBtnChk(true);
        }
    }, [beginTime, endTime, memo]);

    function handleRequest() {
        let formData = new FormData();
        formData.append("company_id", localStorage.getItem("companyId"));
        formData.append("work_history_id", id);
        formData.append("begin_time", beginTime);
        formData.append("end_time", endTime);
        formData.append("memo", memo);

        fatchSet.FatchApi({
            type: "POST",
            formDataItem: formData,
            url: "/work/modify",
            loginType: "login",
            success: (data) => {
                navigate("/workHistory");
            },
            err: (data) => {
                if (data.data || data.alert) {
                    setBottomMsgData({
                        text : data.alert || "",
                        chk : bottomMsgData.chk + 1
                    });
                }
            }
        })
    }

    return (
        <>
            <Header
                pageBack={true}
                func={() => {navigate(-1)}}
                addClass="pageMainBg"
                headTitle="출퇴근 기록 수정"
                centerTitle={true}
                hideRefresh={true}
            />
            <ContentsSection addClass="headerContents pageMainBg">
                <div className="headerItem">
                    <div className="title">{workHistoryData?.work_history?.date_text}</div>
                    <div className="cardContentsBox">
                        <div className="item bgWhite">
                            <div className="label">근무시간</div>
                            <div className="contents">{workHistoryData?.work_history?.contract_begin_time} - {workHistoryData?.work_history?.contract_end_time}</div>
                        </div>
                        <div className="item bgWhite">
                            <div className="label">출퇴근시간</div>
                            <div className="contents">
                                <div className={'flex time'}>
                                    {workHistoryData?.work_history?.real_begin_time} - {workHistoryData?.work_history?.real_end_time ?? workHistoryData?.work_history?.real_begin_time ? <div className={'noInsertTextColor margin-left-5'}>등록안됨</div> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PageBody useYear={false}>
                    <InputSection addClass="registerSection">
                        <div className="companyBtnTextBox mb-20">
                            <InputItemBox
                                addClass={`workHistory`}
                                boxAddClass={'col2'}
                                addInputClass={`${workHistoryData?.work_history?.real_begin_time > workHistoryData?.work_history?.contract_begin_time ? 'dangerTextColor' : workHistoryData?.work_history?.real_begin_time ? '' : 'noInsertTextColor'}`}
                                inputType="text"
                                inputTitle="기존 출근시간"
                                value={workHistoryData?.work_history?.real_begin_time ?? '등록안됨'}
                                disabled={true}
                                max={null}
                                regexp={null}
                            />
                            <InputItemBox
                                addClass={`workHistory`}
                                boxAddClass={'col2'}
                                addInputClass={workHistoryData?.work_history?.real_end_time ? '' : 'noInsertTextColor'}
                                inputType="text"
                                inputTitle="기존 퇴근시간"
                                value={workHistoryData?.work_history?.real_end_time ?? '등록안됨'}
                                disabled={true}
                                max={null}
                                regexp={null}
                            />
                        </div>
                        <div className="companyBtnTextBox mb-20">
                            <InputItemBox
                                boxAddClass={'col2'}
                                inputType="text"
                                inputTitle="변경 출근시간"
                                placeholder={workHistoryData?.work_history?.real_begin_time ?? '-'}
                                maxLength={5}
                                value={beginTime}
                                max={null}
                                regexp={null}
                                func={(value) => {
                                    if (value.length === 4 && !value.includes(':')) {
                                        const minutes = value.slice(0, 2)?.replace(/[^0-9:]/g, "");
                                        const seconds = value.slice(2, 4)?.replace(/[^0-9:]/g, "");
                                        setBeginTime(`${minutes}:${seconds}`);
                                    } else {
                                        setBeginTime(value?.replace(/[^0-9:]/g, ""));
                                    }
                                }}
                                onBlur={(e) => {
                                    let val = e.target.value;

                                    if (val.includes(':')) {
                                        const [minutes, seconds] = val.split(':');

                                        const fixedMinutes = minutes.replace(/[^0-9]/g, '').padStart(2, '0');
                                        const fixedSeconds = (seconds ? seconds.replace(/[^0-9]/g, '') : '').padStart(2, '0');

                                        setBeginTime(`${fixedMinutes}:${fixedSeconds}`);
                                    } else {
                                        // 콜론 없으면 숫자 4자리로 패딩 후 포맷
                                        const raw = val.replace(/[^0-9]/g, '').slice(0, 4);
                                        const padded = raw.padStart(4, '0');
                                        const minutes = padded.slice(0, 2);
                                        const seconds = padded.slice(2, 4);
                                        setBeginTime(`${minutes}:${seconds}`);
                                    }
                                }}
                            />
                            <InputItemBox
                                boxAddClass={'col2'}
                                inputType="text"
                                inputTitle="변경 퇴근시간"
                                placeholder={workHistoryData?.work_history?.real_end_time ?? '-'}
                                maxLength={5}
                                value={endTime}
                                max={null}
                                regexp={null}
                                func={(value) => {
                                    if (value.length === 4 && !value.includes(':')) {
                                        const minutes = value.slice(0, 2)?.replace(/[^0-9:]/g, "");
                                        const seconds = value.slice(2, 4)?.replace(/[^0-9:]/g, "");
                                        setEndTime(`${minutes}:${seconds}`);
                                    } else {
                                        setEndTime(value?.replace(/[^0-9:]/g, ""));
                                    }
                                }}
                                onBlur={(e) => {
                                    let val = e.target.value;

                                    if (val.includes(':')) {
                                        const [minutes, seconds] = val.split(':');

                                        const fixedMinutes = minutes.replace(/[^0-9]/g, '').padStart(2, '0');
                                        const fixedSeconds = (seconds ? seconds.replace(/[^0-9]/g, '') : '').padStart(2, '0');

                                        setEndTime(`${fixedMinutes}:${fixedSeconds}`);
                                    } else {
                                        // 콜론 없으면 숫자 4자리로 패딩 후 포맷
                                        const raw = val.replace(/[^0-9]/g, '').slice(0, 4);
                                        const padded = raw.padStart(4, '0');
                                        const minutes = padded.slice(0, 2);
                                        const seconds = padded.slice(2, 4);
                                        setEndTime(`${minutes}:${seconds}`);
                                    }
                                }}
                            />
                        </div>
                        <TextAreaItem
                            inputTitle="메모"
                            inputName=""
                            placeholder="내용을 입력해주세요"
                            max={500}
                            maxChk={false}
                            value={memo}
                            func={(value) => setMemo(value)}
                        />
                    </InputSection>
                </PageBody>
                <BtnItem
                    addClass=""
                    contents={"수정 신청하기"}
                    disabled={btnChk}
                    func={() => {handleRequest()}}
                />
            </ContentsSection>
            <BottomErrMsg
                text={bottomMsgData.text ? bottomMsgData.text : ""}
                chk={bottomMsgData.chk}
            />
        </>
    );
};

export default ModfiyRequest;